import React from 'react';

export default function RenderRoute (Component, props) {
    return routeProps => <Component {...routeProps} {...props}/>;
}